import { DropdownAction } from "../../../../../components/Dropdown/types";
import { Transaction } from "../../../../../services";
import { TransactionType } from "../../../../../utils";

const PILL_LABELS: Partial<Record<TransactionType, string>> = {
  [TransactionType.INCOME]: "INCOME",
  [TransactionType.EXPENSE]: "EXPENSE",
  [TransactionType.LOAN_PAYMENT]: "LOAN",
  [TransactionType.TRANSFER]: "TRANSFER",
  [TransactionType.INVESTMENT]: "INVESTMENT",
  [TransactionType.MARKET_UPDATE]: "MARKET",
};

export const getPillVariant = (type: TransactionType): string => {
  switch (type) {
    case TransactionType.INCOME:
      return "INCOME";
    case TransactionType.EXPENSE:
      return "EXPENSE";
    case TransactionType.LOAN_PAYMENT:
      return "LOAN";
    case TransactionType.TRANSFER:
      return "TRANSFER";
    default:
      return "DEFAULT";
  }
};

export const getPillLabel = (type: TransactionType): string => {
  return PILL_LABELS[type] ?? String(type).toUpperCase();
};

export const getAmountDisplay = (
  tx: Transaction,
): { sign: string; variant: "income" | "expense" | "neutral" } => {
  if (tx.transactionType === TransactionType.INCOME) {
    return { sign: "+", variant: "income" };
  }
  if (tx.transactionType === TransactionType.TRANSFER) {
    return { sign: "", variant: "neutral" };
  }
  return { sign: "-", variant: "expense" };
};

export const buildDropdownActions = (
  tx: Transaction,
  onEdit: (tx: Transaction) => void,
  onDuplicate: (tx: Transaction) => void,
  onDelete: (tx: Transaction) => void,
): DropdownAction[] => [
  {
    id: "edit",
    label: "Edit",
    icon: "",
    onClick: () => onEdit(tx),
    show: true,
  },
  {
    id: "duplicate",
    label: "Duplicate",
    icon: "",
    onClick: () => onDuplicate(tx),
    show: true,
  },
  {
    id: "delete",
    label: "Delete",
    icon: "",
    onClick: () => onDelete(tx),
    variant: "destructive",
    show: true,
  },
];
